import React from 'react';
import { motion } from 'framer-motion';
const painPoints = ['Lost nights searching for progressions that actually work, flow logically and fit your specific athlete level', 'Sessions that feel repetitive — because you keep returning to the same drills and stations you already know', 'Visible improvisation that quietly erodes your confidence as a coach', 'Limited variety week-to-week — and athletes slowly losing motivation without knowing exactly why', 'Weekends spent planning instead of resting, recharging or living your life'];
export function PainPoints() {
  return <section className="py-20 md:py-24 px-4 bg-mist" data-id="element-181" data-mp="1o03gxs25jtoy">
      <div className="max-w-3xl mx-auto" data-id="element-182" data-mp="1o1ejjojv2veh">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center mb-12" data-id="element-183" data-mp="1sy4z8arr7ozd">
          <h2 className="text-3xl md:text-4xl font-display font-bold uppercase mb-6 text-charcoal" data-id="element-184" data-mp="3nablq5q3ls6z">
            Does this sound familiar?
          </h2>
          <div className="text-lg text-charcoal leading-relaxed bg-white p-6 rounded-2xl border border-sand-deep text-left space-y-4" data-id="element-185" data-mp="1u0it6oxl32nn">
            <p data-id="element-186" data-mp="27v32uffrqdsj">
              Sunday night. 10 PM. You have hybrid fitness racing sessions
              tomorrow morning. And you&apos;re still here — searching online,
              trying to build a session structure that actually flows, one that
              fits your athletes&apos; level, feels professional and
              doesn&apos;t look improvised in twenty minutes.
            </p>
            <p data-id="element-187" data-mp="1p0ef15k5ek0l">
              <span className="text-orange-deep font-semibold" data-id="element-188" data-mp="1k3e68mvwz35s">
                Not because you don&apos;t understand hybrid racing.
              </span>{' '}
              Because nobody ever gave you a complete library, structured and
              ready to coach. You&apos;ve been building every session from
              scratch.
            </p>
            <p data-id="element-189" data-mp="1t4dd6sbooq3k">
              The time you should be resting — you spend planning. And the worst
              part isn&apos;t the exhaustion. The worst part is walking to the
              track feeling you could have been better prepared.
            </p>
          </div>
        </motion.div>

        <div data-id="element-190" data-mp="273v8lqjhj1lw">
          <h3 className="text-xl font-bold uppercase text-charcoal mb-8 text-center" data-id="element-191" data-mp="274ef8b3oq3km">
            The true cost of not having the right resource:
          </h3>
          <ul className="space-y-4" data-id="element-192" data-mp="1efr1r1p6gihm">
            {painPoints.map((point, index) => <motion.li key={point} initial={{
            opacity: 0,
            x: -16
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            amount: 0.4
          }} transition={{
            duration: 0.28,
            delay: index * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex items-start gap-4 bg-white p-4 rounded-xl border border-sand-deep shadow-sm" data-id="element-193" data-mp="1jflpwxhkityz" data-mpi={index}>
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-orange shrink-0" aria-hidden="true" data-id="element-194" data-mp="j7f0l7sbpakc" />
                <span className="text-charcoal" data-id="element-195" data-mp="e695x4f3rd86">{point}</span>
              </motion.li>)}
          </ul>
          <div className="text-center mt-12 pt-8 border-t border-sand-deep" data-id="element-196" data-mp="a8jwc18uaajo">
            <p className="text-2xl font-display font-bold uppercase text-charcoal" data-id="element-197" data-mp="58yspdiq5e0m">
              Stop giving away your time. Your dedication is already there.
            </p>
            <p className="text-xl mt-4 text-warmgray" data-id="element-198" data-mp="3ro0biu4imdq3">
              What you need now is{' '}
              <span className="text-orange font-semibold" data-id="element-199" data-mp="3mox6vasg69in">
                the right tool.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}